<template>
  <table class="listables-table">
    <thead>
      <th>Name</th>
      <th>Level</th>
      <th>Conditions</th>
      <th>Description</th>
    </thead>
    <tr v-for="obstacle in obstacles">
      <td v-html="colorize(obstacle.name)"></td>
      <td>{{ obstacle.level }}</td>
      <td v-html="colorize(obstacle.conditionals)"></td>
      <td v-html="colorize(obstacle.description)"></td>
    </tr>
  </table>
</template>

<script>
import colorizeKeywords from './colorize.js';

export default {
  name: 'obstacles',

  methods: {
    colorize(text) { return colorizeKeywords(text); }
  },

  props: {
    obstacles: {
      type: Array,
      default: () => []
    }
  }
}
</script>
